import { AffectedDevice } from '@raydiant/api-client-js';
import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import Button from '@raydiant/raydial/components/Button';
import Text from '@raydiant/raydial/components/Text';

interface DeleteLocationDialogProps {
  isOpen: boolean;
  resourceName?: string;
  affectedDevices: AffectedDevice[];
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const BatchDeleteContentDialog = ({
  isOpen,
  resourceName,
  affectedDevices,
  isLoading,
  onClose,
  onSubmit,
}: DeleteLocationDialogProps) => {
  let affectedDevicesMessage = '';
  if (affectedDevices.length > 0) {
    if (resourceName) {
      if (affectedDevices.length > 1) {
        affectedDevicesMessage = `${resourceName} is used on ${affectedDevices.length} screens`;
      } else if (affectedDevices.length === 1) {
        affectedDevicesMessage = `${resourceName} is used on 1 screen`;
      }
    } else {
      if (affectedDevices.length > 1) {
        affectedDevicesMessage = `This content is used on ${affectedDevices.length} screens`;
      } else if (affectedDevices.length === 1) {
        affectedDevicesMessage = `This content is used on 1 screen`;
      }
    }
  }

  return (
    <Modal isOpen={isOpen}>
      <Dialog showCloseButton={true} onClose={onClose}>
        <DialogHeader>
          <DialogHeading>
            <span className="text-black">Confirm delete contents</span>
          </DialogHeading>
        </DialogHeader>

        <div className="px-4 py-6">
          {affectedDevices.length > 0 && (
            <div className="mb-4">
              <Text className="text-black" variant="body">
                - {affectedDevicesMessage}
              </Text>
            </div>
          )}

          <Text className="text-black" variant="body">
            Are you sure you want to delete these contents? This cannot be
            undone.
          </Text>
        </div>

        <div className="flex flex-col-reverse justify-between pt-2 pb-4 gap-3 px-0 md:gap-6 md:flex-row md:px-4">
          <Button
            onPress={() => onClose()}
            variant="secondary"
            size="large"
            className="grow"
            isDisabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            onPress={() => onSubmit()}
            variant="caution"
            size="large"
            className="grow"
            isDisabled={isLoading}
            loading={isLoading}
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    </Modal>
  );
};

export default BatchDeleteContentDialog;
